import React from 'react';
import {LinkOnComponent} from 'app/components/links/link';
import VideoPreview from 'app/components/tv/preview/VideoPreview';
import WatchedPlaylist from 'app/components/tv/utils/WatchedPlaylist';
import DateModel from 'app/models/DateModel';

const isSporttotalVideo = source => {
  return source === 'Sporttotal';
};

export const PlaylistTeaser = ({playlist}) => {
  const isWatched = new WatchedPlaylist(playlist.id).isWatched(playlist.data.videosCount);

  const updateTime = DateModel.fromTimestamp(playlist.updatedAt * 1000).getRelativeTime();

  let caption = isSporttotalVideo(playlist.data.source)
    ? updateTime
    : `${playlist.data.videosCount} Clips | ${updateTime}`;

  return (
    <LinkOnComponent to={`/tv/match/${playlist.data.slug}`}>
      <VideoPreview
        thumbnail={playlist.thumbnail}
        updated={!isWatched}
        source={playlist.data.source}
        title={playlist.data.creatorName ? `von ${playlist.data.creatorName}` : 'Video-Playlist'}
        caption={caption}
      />
    </LinkOnComponent>
  );
};
